export default function AboutMe() {
  return (
    <section id="AboutMe" className="about--section">
      <div className="about--section--img">
        <img src="./images/faskaaa.jpeg" alt="About Me" />
      </div>
      <div className="hero--section--content--box about--section--box">
        <div className="hero--section--content">
          {/* <p className="section--title">About</p> */}
          <h1 className="skills--section--heading">About Me</h1>
          <p className="hero--section-description">
            Hello! I'm Faiso Abdirisak, a passionate programmer and problem
            solver with a love for crafting elegant code. Ever since I was a
            kid, I've been fascinated by the world of technology and computers,
            and that fascination has only grown stronger over the years. I'm
            thrilled to be a part of this ever-evolving field, where creativity
            and innovation know no bounds.
          </p>
          <p className="hero--section-description">
            I have experience working on a diverse range of projects, from
            creating web applications that provide seamless user experiences to
            developing efficient algorithms for data processing. My expertise
            extends to languages such as Python, Java, and JavaScript, as well
            as frameworks like Django, angular, and React.
          </p>
          <a
            href="https://drive.google.com/file/d/1LcF1cFW20UWsAIHnW68Qm7feP2eiM-2y/view?usp=sharing" target="_blank"
            download
            className="btn btn-primary"
          >
            Download CV
          </a>
        </div>
      </div>
    </section>
  );
}
